<template>
  <div class="extra--content-wrapper">
    <div class="extra-item">
      <div class="extra-picture">
        <img :src="picture" alt="">
      </div>
      <div class="extra-content">
        <div class="extra-title">{{name}}</div>
        <div class="extra-dates">
          <div class="date" v-for="(i, index) in dates" :index="index" :key="i.day + index">
            <div class="date-label">
              <span class="primary">{{i.qte}}</span> x <span>{{i.day}}</span>
            </div>
            <div class="date-price">
              <span>{{i.price | decimalPrice}} €</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .extra-picture img {
    width: 40px;
    height: 40px;
  }
  .extra--content-wrapper {
    padding-left: 10px;
    position: relative;
    padding-top: .4rem;
  }
  .extra-item {
    display: grid;
    grid-template-columns: 40px 1fr;
  }
  .extra-item img {
    border-radius: 6px;
  }
  .extra-item .extra-content {
    margin-left: 1rem;
    font-size: .9em;
    color: #a2acb2;
  }
  .extra-item .extra-content .extra-title {
    margin-bottom: .4rem;
    color: #fff;
  }
  .extra--content-wrapper::after {
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 100%;
    background: #c15842;
    left: -3px;
    border: 2px solid #141416;
    top: calc(14px + .4rem);
  }
  .date {
    display: flex;
  }
  .date .date-label {
    flex: 1 1 auto;
    margin: auto auto auto 0;
  }
  .date .date-price {
    flex: 0 0 auto;
    margin: auto 0 auto 0;
    text-align: right;
    color: #c15842;
  }
  .room-wrapper:hover .date .date-price {
    color: #fff;
  }
  .room-wrapper:hover .extra-item .extra-content {
    color: #d6e4eb;
  }
</style>
<script>
  import moment from 'moment';
  export default {
    name: "cart-extra",
    props: ['item'],
    computed: {
      name () {
        return this.item.extra.text.name;
      },
      picture () {
        return `${this.item.extra.picture}?w=80&h=80&crop-to-fit`
      },
      dates () {
        return this.item.dates.map(d => {
          return {
            day: moment(d.date).format('DD MMMM'),
            qte: d.count,
            price: this.item.extra.price.amount * d.count
          }
        })
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/topbar/cart-extra.vue